<div #focusQuote name="focusQuote" id="focusQuote" class="d-flex quote-page-main flex-column">
	<app-quote-focus-logo></app-quote-focus-logo>
	<div *ngIf="quoteService.quote.value?.Id">
		<app-quote-header></app-quote-header>

		<app-quote-line-items></app-quote-line-items>
		<app-quote-financials></app-quote-financials>
		<app-quote-payment-processing-rates *ngIf="quoteService.quote.value.Payment_Processing_Rate__r"></app-quote-payment-processing-rates>
		<app-quote-new-system-terms *ngIf="quoteService.quote.value.Opportunity.RecordTypeId === '01216000001BMocAAG'"></app-quote-new-system-terms>
		<app-quote-accept-and-order
			*ngIf="quoteService.quote.value.Status !== 'Accepted' && quoteService.quote.value.Status !== 'Rejected'"
		></app-quote-accept-and-order>
		<div class="footer">
			<p-divider></p-divider>
			<app-quote-footer></app-quote-footer>
		</div>
	</div>
</div>
